import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectAuthIsLoading, selectAuthState } from 'store/authslice'
import { selectLoginPage } from 'store/settingsSlice'
import { Spinner } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'

interface Props {
  children: JSX.Element | null
  title?: string
}

export const PrivateRoute = (props: Props): JSX.Element => {
  const authState = useSelector(selectAuthState)
  const isLoading = useSelector(selectAuthIsLoading)
  const loginPage = useSelector(selectLoginPage)

  // authorized so return child components
  if (authState.isAuthenticated)
    return (
      <>
        <Helmet>{props.title && <title>{props.title}</title>}</Helmet>
        {props.children}
      </>
    )

  if (isLoading) {
    return (
      <div className="p-4 justify-content-center align-items-center d-flex vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }

  // If not authorized, return to login
  if (loginPage) return <Navigate to={loginPage.permaLink} />

  // If not authorized and no login page, return to home
  return <Navigate to="/" />
}
